import { ISidebarMenuItem } from "./SidebarMenuItem";

// A menu item owns its detail routes as well as its own path.
//
// This compared paths with `==`, so any route below a menu item — /sessions/:id,
// /organizations/:orgSlug — matched nothing and the sidebar lost its highlight
// entirely. Nothing appeared selected, which reads as "you have navigated out of
// the admin app" at exactly the moment you have gone deeper into it.
//
// The boundary matters: a bare prefix test would let /organizations claim
// /organizations-archive. Requiring the separator keeps sibling paths distinct,
// and /email-organizations stays unrelated to /organizations either way.
const owns = (itemUrl: string | undefined, url: string) =>
    Boolean(itemUrl) && (itemUrl === url || url.startsWith(`${itemUrl}/`));

const findItem = (menuItems: ISidebarMenuItem[], url: string): ISidebarMenuItem | null => {
    for (const item of menuItems) {
        if (owns(item.url, url)) {
            return item;
        }
        if (item.children) {
            const fItem = findItem(item.children, url);
            if (fItem) {
                return fItem;
            }
        }
    }
    return null;
};

export const getActivatedItemParentKeys = (menuItems: ISidebarMenuItem[], url: string): Set<string> => {
    const menuItem = findItem(menuItems, url);

    if (!menuItem) return new Set();
    const list = [];

    for (const item of menuItems) {
        if (item.id == menuItem.id) {
            list.push(item.id);
        }
        if (item.children) {
            for (const iItem of item.children) {
                if (iItem.id == menuItem.id) {
                    list.push(item.id);
                    list.push(iItem.id);
                }
                if (iItem.children != null) {
                    for (const i2Item of iItem.children) {
                        if (i2Item.id == menuItem.id) {
                            list.push(item.id);
                            list.push(iItem.id);
                            list.push(i2Item.id);
                        }
                    }
                }
            }
        }
    }
    return new Set(list);
};
